<template>
  <div id="filters">
    <ul class="row no-gutters mb-n1 lg:mb-n2 ml-n1 lg:ml-n2 pb-3 md:pb-4 lg:pb-5 xl:pb-6 list-unstyled">
      <li
        v-for="property in properties"
        :key="property"
        class="col-auto pb-1 lg:pb-2 pl-1 lg:pl-2"
      >
        <button
          type="button"
          class="btn py-1 sm:py-2 px-2 md:px-3 lg:px-4 font-medium rounded-pill"
          :class="isInFilter(property.systemName) ? 'btn-primary' : 'btn-outline-primary'"
          @click="productStore.toggleFilter(property.systemName)"
        >
          <i :class="[`mi-${property.icon} hidden sm:block my-n1 mr-2 lg:mr-3 mi-no-mx icon-filter`]" />
          <span class="hidden md:block">{{ property.name }}</span>
          <span class="small md:hidden">{{ property.name }}</span>
          <i
            v-if="isInFilter(property.systemName)"
            class="mi-times ml-1 sm:ml-2 lg:ml-3"
          />
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'

import { useProductStore } from '@/stores/ProductStore'

const { t } = useI18n()
const productStore = useProductStore()
const { isInFilter } = storeToRefs(productStore)

const properties = [
  {
    name: t('for_vegan'),
    systemName: 'for_vegan',
    icon: 'vegan',
  },
  {
    name: t('no_lactose'),
    systemName: 'no_lactose',
    icon: 'no-lactose',
  },
  {
    name: t('no_gluten'),
    systemName: 'no_gluten',
    icon: 'no-gluten',
  },
  {
    name: t('no_added_sugar'),
    systemName: 'no_added_sugar',
    icon: 'no-sugar',
  },
  {
    name: t('discount'),
    systemName: 'discount',
    icon: 'discount',
  },
  {
    name: t('protein'),
    systemName: 'protein',
    icon: 'protein',
  },
]
</script>

<style lang="scss">
.icon-filter{ font-size: 24px; }
</style>

<i18n>
  {
    "cs": {
    "discount": "Mixy v akci",
    "for_vegan": "Vegan",
    "no_added_sugar": "Bez přidaného cukru",
    "no_gluten": "Bez lepku",
    "no_lactose": "Bez laktózy",
    "protein": "Protein"
},
    "sk": {
    "discount": "Mixy v akcii",
    "for_vegan": "Vegán",
    "no_added_sugar": "Bez pridaného cukru",
    "no_gluten": "Bez lepku",
    "no_lactose": "Bez laktózy",
    "protein": "Proteín"
},
    "pl": {
    "discount": "Mixy w promocji",
    "for_vegan": "Wegański",
    "no_added_sugar": "Bez dodatku cukru",
    "no_gluten": "Bez glutenu",
    "no_lactose": "Bez laktozy",
    "protein": "Proteina"
},
    "hu": {
    "discount": "Akciós Mixit",
    "for_vegan": "Vegán",
    "no_added_sugar": "Hozzáadott cukor nélkül",
    "no_gluten": "Gluténmentes",
    "no_lactose": "Laktózmentes",
    "protein": "Fehérje"
},
    "de": {
    "discount": "Aktion",
    "for_vegan": "Vegan",
    "no_added_sugar": "Ohne Zuckerzusatz",
    "no_gluten": "Glutenfrei",
    "no_lactose": "Laktosefrei",
    "protein": "Protein"
},
    "at": {
    "discount": "Aktion",
    "for_vegan": "Vegan",
    "no_added_sugar": "Ohne Zuckerzusatz",
    "no_gluten": "Glutenfrei",
    "no_lactose": "Laktosefrei",
    "protein": "Protein"
},
    "ro": {
    "discount": "Amestecuri cu reducere",
    "for_vegan": "Vegan",
    "no_added_sugar": "Fără zahăr adăugat",
    "no_gluten": "Fără gluten",
    "no_lactose": "Fără lactoză",
    "protein": "Proteine"
},
    "fr": {
    "discount": "Mix en promotion",
    "for_vegan": "Végan",
    "no_added_sugar": "Sans sucre ajouté",
    "no_gluten": "Sans gluten",
    "no_lactose": "Sans lactose",
    "protein": "Protéines"
}
  }
</i18n>
